// This function will return true if 'array' is an array of 'classOrPrimitiveType',
// where the latter can be a type string such as 'object', or a class type such as Tag.
// Empty arrays will also return true
// The following examples should return true:
// isArrayOfType([1,2], 'number')
// isArrayOfType(['a', 'b'], 'string')
// isArrayOfType([new Tag(),new Tag()], 'object')
// isArrayOfType([new Tag(),new Tag()], Tag)
export function isArrayOfType(array, classOrPrimitiveType) {
  if (!(array instanceof Array)) {
    return false;
  }
  if (typeof classOrPrimitiveType === 'function') {
    return array.every((it) => it instanceof classOrPrimitiveType);
  }
  return array.every((it) => typeof it === classOrPrimitiveType);
}

export function isArrayOfEnum(array, enumType) {
  if (!(array instanceof Array)) {
    return false;
  }
  return array.every((it) => Object.values(enumType).includes(it));
}
